/**
 * ログページネーションコンポーネント
 *
 * ページ切り替えと件数表示を提供
 */

import { Stack, Center, Pagination, Divider, Text } from "@mantine/core";

interface LogsPaginationProps {
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  onPageChange: (page: number) => void;
}

/**
 * ログページネーション
 */
export function LogsPagination({
  total,
  page,
  pageSize,
  loading,
  onPageChange,
}: LogsPaginationProps) {
  return (
    <Stack gap="xs" mt="auto">
      <Divider />
      <Center>
        <Pagination
          total={Math.ceil(total / pageSize)}
          value={page}
          onChange={onPageChange}
          size="sm"
          radius="md"
          withEdges
        />
      </Center>
      <Text size="10px" c="dimmed" ta="center">
        {total > 0 ? (
          `全 ${total} 件中 ${(page - 1) * pageSize + 1} - ${Math.min(page * pageSize, total)} 件を表示`
        ) : loading ? (
          "読み込み中..."
        ) : (
          `全 ${total} 件`
        )}
      </Text>
    </Stack>
  );
}
